import { render, staticRenderFns } from "./DashboardButtonGroup.vue?vue&type=template&id=0937dc98&"
import script from "./DashboardButtonGroup.vue?vue&type=script&lang=js&"
export * from "./DashboardButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./DashboardButtonGroup.vue?vue&type=style&index=0&id=0937dc98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports